import React from "react";
import { getProgressPoint } from "../../../helpers/bar-helper";
import { BarDisplay } from "./bar-display";
import { BarDateHandle } from "./bar-date-handle";
import { BarProgressHandle } from "./bar-progress-handle";
import { TaskItemProps } from "../task-item";
import styles from "./bar.module.css";

export const Bar: React.FC<TaskItemProps> = ({
  task,
  isProgressChangeable,
  isDateChangeable,
  rtl,
  onEventStart,
  isSelected,
  onMilestoneMouseEnter,
  onMilestoneMouseLeave,
}) => {

  const progressPoint = getProgressPoint(
    +!rtl * task.progressWidth + task.progressX ,
    task.y+2,
    task.height -2
  );
  const handleHeight = task.height - 2;
  return (
    <g className={styles.barWrapper} tabIndex={0} data-taskid={task.id} data-type="Task">
      <BarDisplay
        task={task}
        x={task.x1}
        y={task.y}
        width={task.x2 - task.x1}
        height={task.height}
        progressX={task.progressX}
        progressWidth={task.progressWidth}
        barCornerRadius={task.barCornerRadius}
        styles={task.styles}
        isSelected={isSelected}
        onMouseDown={e => {
          isDateChangeable &&  onEventStart(e.button == 0 ? "move":"", task, e);
        }}
      />
      <g className="handleGroup">
        {isDateChangeable && (
          <g>
            {/* left */}
            {/* <BarDateHandle
              x={task.x1 }
              y={task.y + 1}
              width={task.handleWidth-5}
              height={handleHeight}
              barCornerRadius={task.barCornerRadius}
              onMouseDown={e => {
                onEventStart("start", task, e);
              }}
            /> */}
            {/* right */}
            <BarDateHandle
              x={task.x2 - 2}
              y={task.y + 1}
              width={task.handleWidth-5}
              height={handleHeight}
              barCornerRadius={task.barCornerRadius}
              onMouseDown={e => {
                onEventStart("end", task, e);
              }}
            />
          </g>
        )}
        {isProgressChangeable && (
          <BarProgressHandle
            progressPoint={progressPoint}
            onMouseDown={e => {
              onEventStart("progress", task, e);
            }}
          />
        )}
      </g>

      {/* Render Milestone Diamonds on the bar */}
      {task.milestones && 
       task.milestones.length > 0 && 
       (task.id.endsWith("-act") || (!task.id.endsWith("-recalc") && (!task.id.endsWith("-est") || !task.baseLineTask?.length))) &&
       task.milestones.map((milestone) => {
        const diamondSize = 12;
        const centerY = task.y + task.height / 2;
        const transform = `rotate(45 ${milestone.x} ${centerY})`;

        return (
          <g key={milestone.id} className="milestone-marker">
            {/* Milestone Label */}
            {/* <text
              x={milestone.x}
              y={isProjectsPage ? task.y + task.height + 15 : task.y - 6}
              textAnchor="middle"
              fontSize="10"
              fontWeight="600"
              fill="#1e293b"
              className="select-none pointer-events-none"
              style={{
                paintOrder: 'stroke',
                stroke: '#fff',
                strokeWidth: '3px',
                strokeLinejoin: 'round' as const,
              }}
            >
              {milestone.name}
            </text> */}

            {/* Milestone Diamond */}
            <rect
              x={milestone.x - diamondSize / 2}
              y={centerY - diamondSize / 2}
              width={diamondSize}
              height={diamondSize}
              fill={milestone.color || task.styles.backgroundColor}
              stroke="#ffffff"
              strokeWidth="1.5"
              transform={transform}
              className="pointer-events-none"
              style={{ filter: 'drop-shadow(0px 1px 2px rgba(0,0,0,0.25))' }}
            />
            {onMilestoneMouseEnter && onMilestoneMouseLeave && (
              <rect
                data-milestone-hit="true"
                x={milestone.x - 10}
                y={centerY - 10}
                width={20}
                height={20}
                fill="transparent"
                className="cursor-pointer"
                style={{ pointerEvents: "auto" }}
                onMouseEnter={(e) => {
                  e.stopPropagation();
                  onMilestoneMouseEnter(e, milestone);
                }}
                onMouseLeave={(e) => {
                  e.stopPropagation();
                  onMilestoneMouseLeave(e);
                }}
              />
            )}
          </g>
        );
      })}
    </g>
  );
};
